export default __webpack_public_path__ + "static/media/shopping-cart-small-white.c6b4cffc.svg";